import * as React from 'react'
import {Checkbox} from '@frontrow/console/src/components/ui/checkbox'

type Props = {
  courseSubjectsByLicensing: boolean
  setCourseSubjectsByLicensing: (courseSubjectsByLicensing: boolean) => void
}

export default function SchoolCourseSubjectsByLicensingToggle({
  courseSubjectsByLicensing,
  setCourseSubjectsByLicensing
}: Props): React.ReactElement {
  return (
    <Checkbox
      id="course-subjects-by-licensing-checkbox"
      checked={courseSubjectsByLicensing}
      value="setCourseSubjectsByLicensing"
      onChange={() => setCourseSubjectsByLicensing(!courseSubjectsByLicensing)}
    />
  )
}
